import { zodResolver } from '@hookform/resolvers/zod'
import { Box, Grid } from '@mui/material'
import { useCallback, useContext, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSubmitOperacion } from '../../hooks/useSubmitOperacion'
import { ContextOperacionNuevo, ContextOperacionNuevoType } from '../../NuevoSistema'
import { HttpADCM } from './api/httpADCM'
import { OperacionADCMInsert, schemaOperacionADCMInsert } from './types/dto'
import { OperacionADCMFields } from './types/fields'
import { SeccionNuevoADCMDatosOperacion } from './components/OperacionADCMNuevoDatosOperacion'
import { SeccionNuevoADCMDetalleTransaccion } from './components/SeccionNuevoADCMDetalleTransaccion'
import { SeccionNuevoADCMUnderwriting } from './components/SeccionNuevoADCMUnderwriting'
import { SeccionNuevoADCMBridgeLoan } from './components/SeccionNuevoADCMBridgeLoan'
import SeccionNuevoADCMArchivo from './components/SeccionNuevoADCMArchivo '

interface NuevoSistemaADCMProps {
  codSistemaPrincipal: number
}

const NuevoSistemaADCM = ({ codSistemaPrincipal }: NuevoSistemaADCMProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const formMethods = useForm<OperacionADCMInsert>({
    resolver: zodResolver(schemaOperacionADCMInsert),
    defaultValues: {
      [OperacionADCMFields.FechaSolicitud]: new Date(),
      [OperacionADCMFields.CodPais]: codSistemaPrincipal,

      [OperacionADCMFields.NroCuenta]: '',
    }
  })



  const handleCrearOperacion = useCallback(
    (data: OperacionADCMInsert) => {
      submitOperacion(data, {
        apiCall: HttpADCM.post,
        codSistemaPrincipal,
      });
    },
    [codSistemaPrincipal, submitOperacion]
  );

  const { setSavePromise, setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    setSendPromise(() => formMethods.handleSubmit(handleCrearOperacion))
  }, [formMethods, handleCrearOperacion, setSavePromise, setSendPromise])


  return (
    <Box>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionNuevoADCMDatosOperacion formMethods={formMethods} codSistema={codSistema} codPais={codSistemaPrincipal} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoADCMDetalleTransaccion formMethods={formMethods} codPais={codSistemaPrincipal} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoADCMUnderwriting formMethods={formMethods} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoADCMBridgeLoan formMethods={formMethods} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoADCMArchivo formMethods={formMethods} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default NuevoSistemaADCM
